<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit Beli Lepas' : 'Beli Lepas' }}</h5>
            </b-card-header>
            <b-card-body v-if="viewMode || isKonfirmasi">
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th>Gudang</th>
                            <td>:</td>
                            <th class="text-primary">{{ form.gudang ? form.gudang.name : '' }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th>Tanggal Pembelian</th>
                            <td>:</td>
                            <th class="text-primary">{{ formatDate(form.created_at) }}</th>
                        </tr>
                        <tr>
                            <th>Grader</th>
                            <td>:</td>
                            <th class="text-primary">{{ form.grader ? form.grader.name : (isKonfirmasi ? $gate.user.name : '') }}</th>
                        </tr>
                        <tr>
                            <th>Nama Supplier</th>
                            <td>:</td>
                            <th class="text-primary">{{ form.supplier ? form.supplier.name : '' }}</th>
                        </tr>
                        <tr>
                            <th>Catatan</th>
                            <td>:</td>
                            <th class="text-primary">{{ form.note }}</th>
                        </tr>
                    </table>
                </div>

                <div class="table-responsive mt-3">
                    <table class="table table-borderless">
                        <tr>
                            <th colspan="3">Detail Barang :</th>
                        </tr>
                        <tr>
                            <th v-if="!isKonfirmasi">Kode</th>
                            <th>Berat</th>
                            <th>Grade</th>
                        </tr>
                        <tr>
                            <th class="text-primary" v-if="!isKonfirmasi">{{ form.code }}</th>
                            <th class="text-primary">{{ formatNumber(form.bobot) }} KG</th>
                            <th class="text-primary">{{ form.grade ? form.grade.name : '' }}</th>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-body v-else>
                <div class="form-group">
                    <label class="form-control-label">Gudang</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect class="w-auto flex-grow-1" v-validate="'required'" name="gudang" v-model="form.gudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                            label="name" track-by="id" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih Gudang</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('gudang') }}</span>
                </div>

                <div class="form-group">
                    <label>Grader</label>
                    <input v-validate="'required'" readonly v-model="graderName" type="text" name="grader" class="form-control bg-white">
                    <span class="text-danger">{{ errors.first('grader') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Nama Supplier</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect class="w-auto flex-grow-1" v-validate="'required'" name="supplier" v-model="form.supplier" :options="supplierOptions" :placeholder="'Pilih supplier'" :searchable="true"
                            label="name" track-by="id" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectSupplier = true"><i class="fas fa-search"></i> Pilih Supplier</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('supplier') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Grade</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect class="w-auto flex-grow-1" v-validate="'required'" name="grade" v-model="form.grade" :options="gradeOptions" :placeholder="'Pilih grade'" :searchable="true"
                            label="name" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectGrade = true"><i class="fas fa-search"></i> Pilih Grade</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('grade') }}</span>
                </div>

                <div class="form-group">
                    <label>Bobot</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.bobot" type="number" name="bobot" class="form-control">
                    <span class="text-danger">{{ errors.first('bobot') }}</span>
                </div>
                <div class="form-group">
                    <label>Catatan</label>
                    <input v-validate="'max:20'" v-model="form.note" type="text" name="note" class="form-control">
                    <span class="text-danger">{{ errors.first('note') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">{{ viewMode ? 'OK' : 'Batal' }}</button>
                <button :disabled="isLoading" v-if="!isEdit && !isKonfirmasi && !viewMode" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button :disabled="isLoading" v-if="isEdit" @click="save(false)" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="save(true)" type="button" class="btn btn-primary mr-2">Cetak</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :supplier-id="form.supplier ? form.supplier.id : null" :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectSupplier" size="lg" :hide-header="true" :hide-footer="true">
            <supplier-selector :gudang-id="form.gudang ? form.gudang.id : null" :selected="supplierOptions" is-pembelian-tembakau @selected="supplierSelected" @cancel="selectSupplier = false"></supplier-selector>
        </b-modal>

        <b-modal v-model="selectGrade" size="lg" :hide-header="true" :hide-footer="true">
            <grade-selector :selected="gradeOptions" @selected="gradeSelected" @cancel="selectGrade = false"></grade-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';
import SupplierSelector from '../suppliers/Selector';
import GradeSelector from '../grades/Selector';

export default {
    name: "beli-lepas-form",

    props: {
        isEdit: {
            type: Boolean,
            default: () => {},
        },

        value: {
            type: Object,
            default: null,
        }
    },

    components: {
        Multiselect,
        GudangSelector,
        SupplierSelector,
        GradeSelector,
    },

    data() {
        return {
            form: null,
            selectGudang: false,
            gudangOptions: [],
            selectSupplier: false,
            supplierOptions: [],
            selectGrade: false,
            gradeOptions: [],
            isKonfirmasi: false,
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        this.initForm();
    },

    computed: {
        graderName() {
            return this.form.grader ? this.form.grader.name : this.$gate.user.name;
        },
    },

    watch: {
        value() {
            this.initForm();
        }
    },

    methods: {
        initForm() {
            let self = this;

            self.form.gudang = Object.assign({}, self.userGudang);
            if (self.value) {
                self.form = Object.assign({}, self.value);
            }
            if (self.form.gudang) {
                self.gudangOptions.push(Object.assign({}, self.form.gudang));
            }
            if (self.form.supplier) {
                self.supplierOptions.push(Object.assign({}, self.form.supplier));
            }
        },
        resetForm() {
            this.form = Object.assign({}, {
                form: {
                    id: '',
                    gudang: null,
                    grader: null,
                    supplier: null,
                    grade: null,
                    bobot: '',
                    note: '',
                }
            });
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        save(isPrint) {
            let self = this;

            self.isLoading = true;
            let data = {
                gudang_id: self.form.gudang.id,
                grader_id: self.form.grader ? self.form.grader.id : self.$gate.user.id,
                supplier_id: self.form.supplier.id,
                grade_id: self.form.grade.id,
                bobot: self.form.bobot,
                note: self.form.note ?? null,
            }

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: self.isEdit ? '/api/beli-lepas/'+self.form.id : '/api/beli-lepas',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                if (isPrint) {
                    self.print(response.data.data);
                } else {
                    self.$emit('saved', response.data.data);
                }
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        gudangSelected(gudang) {
            let self = this;

            if (!self.form.supplier) {
                self.supplierOptions = [];
            }
            self.gudangOptions = [];
            self.gudangOptions.push(gudang);
            self.form.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        supplierSelected(supplier) {
            let self = this;

            if (!self.form.gudang) {
                self.gudangOptions = [];
            }
            self.supplierOptions = [];
            self.supplierOptions.push(supplier);
            self.form.supplier = Object.assign({}, supplier);
            self.selectSupplier = false;
        },

        gradeSelected(grade) {
            let self = this;

            self.gradeOptions.push(grade);
            self.form.grade = Object.assign({}, grade);
            self.selectGrade = false;
        },

        print(data) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/beli-lepas/print/'+data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('saved', data);
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },
    },
}
</script>
<style>
.multiselect__placeholder {
    margin-bottom: 0;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
